<template lang="html">
  <div class="user-cash-history--inner">
    <div class="user-details-toolbar">
      <div class="user-details-toolbar__items">
        <select-list
          class="toolbar-nav"
          :title="$route.params.subtype"
          v-model="selectedList"
        >
          <select-option
            value="all"
            name="all"
          >
              <span>all</span>
          </select-option>

          <select-option
            value="cash-in"
            name="cash in"
          >
              <span>cash in</span>
          </select-option>

          <select-option
            value="cash-out"
            name="cash out"
          >
              <span>cash out</span>
          </select-option>
        </select-list>

        <search
          class="search-bar-wrap"
          :dateBy="dateBy"
          :filterBy="filterBy"
          @trigger="trigger"
          @refresh="search"
          @clear="search"
        >
        </search>
      </div>
    </div>

    <check-data-list
      label="loading"
      v-if="isDataLoading || isEmpty"
      :isLoading="isDataLoading"
      :isEmpty="isEmpty"
    >
    </check-data-list>
    <tbl
      :scrollable="true"
      :dataLoading="isDataLoading"
      :class="{'data-loading': showDataLoading}"
      v-else
    >
      <tbl-inner>
        <tbl-head>
          <tbl-row>
            <tbl-td
              :sort="true"
              name="no"
              @click.native="sort('id')"
            >
              no
            </tbl-td>

            <tbl-td
              :sort="true"
              name="request-date"
              @click.native="sort('created_at')"
            >
              request date
            </tbl-td>

            <tbl-td
              :sort="true"
              name="before-transfer"
              @click.native="sort('old_balance')"
            >
              before-transfer
            </tbl-td>

            <tbl-td
              name="amount"
              :sort="true"
              @click.native="sort('amount')"
            >
              amount
            </tbl-td>

            <tbl-td
              :sort="true"
              name="new-balance"
              @click.native="sort('new_balance')"
            >
              new balance
            </tbl-td>

            <tbl-td
              :sort="true"
              name="user-ip"
              @click.native="sort('type_id')"
            >
              type
            </tbl-td>

            <tbl-td
              :sort="true"
              name="status"
              @click.native="sort('status')"
            >
              status
            </tbl-td>

            <tbl-td
              :sort="true"
              name="confirm-date"
              @click.native="sort('updated_at')"
            >
              confirm date
            </tbl-td>

            <tbl-td
              :sort="true"
              name="user-ip"
              @click.native="sort('ip')"
            >
              user ip
            </tbl-td>

            <tbl-td
              :sort="true"
              name="from"
              @click.native="sort('domain')"
            >
              admin
            </tbl-td>
          </tbl-row>
        </tbl-head>

        <tbl-body>
          <tbl-row
            v-for="(transfer, x) in transferDetails"
            :key="transfer.id"
          >
            <tbl-td name="no">
              {{ generateNumber(x, params.page, params.rows, params.sort, count || 0) }}
            </tbl-td>

            <tbl-td name="request-date">
              {{transfer.created_at | date}}
            </tbl-td>

            <tbl-td name="before-transfer">
              {{transfer.old_balance | FormatAmount('whole')}}
            </tbl-td>

            <tbl-td name="amount">
              {{transfer.amount | FormatAmount('whole')}}
            </tbl-td>

            <tbl-td name="new-balance">
              <span>{{ transfer.new_balance | FormatAmount('whole') }}</span>
            </tbl-td>

            <tbl-td name="type">
              {{transfer.type_id | getCashType}} {{transfer.type_id}}
            </tbl-td>

            <tbl-td name="status">
              {{transfer.status | status}}
            </tbl-td>

            <tbl-td name="confirm-date">
              {{transfer.updated_at | date}}
            </tbl-td>

            <tbl-td name="user-ip">
              <span  v-if="transfer.ip">{{transfer.ip}}</span>
              <span  v-else>-</span>
            </tbl-td>

            <tbl-td name="from">
              <span  v-if="transfer.admin">{{transfer.admin.login_id}}</span>
              <span  v-else>-</span>
            </tbl-td>
          </tbl-row>
        </tbl-body>
      </tbl-inner>

      <tbl-footer>
        <pagination
          :total="count"
          v-model="params.page"
          :rows="params.rows"
          @page="trigger"
        >
        </pagination>
      </tbl-footer>

    </tbl>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
//= mixins
import { getListStatus } from '@/assets/js/mixins/common/GetListStatus'

//= components
import Modal from '@/components/base/Modal'
import Search from '@/components/base/search/Search'
import CheckDataList from '@/components/base/CheckDataList'
import Pagination from '@/components/base/Pagination'
//= filters
import FormatAmount from '@/assets/js/filters/FormatAmount'

export default {
  name: 'user-cash-info-history',

  components: {
    Modal,
    Search,
    CheckDataList,
    Pagination
  },

  mixins: [
    getListStatus
  ],

  created () {
    this.search()
  },

  computed: {
    ...mapState('transfer', ['transferDetails', 'count'])
  },

  filters: {
    FormatAmount,
    getCashType (type) {
      if (type === 3) {
        return 'cash in'
      }
      return 'cash out'
    },

    status (stat) {
      let status = ''
      switch (stat.toLowerCase()) {
        case 'c':
          status = 'confirmed'
          break
        case 'r':
          status = 'rejected'
          break
        case 'w':
          status = 'waiting'
          break
        case 'p':
          status = 'pending'
          break
        case 'b':
          status = 'ban'
          break
        case 'd':
          status = 'deleted'
          break
      }
      return status
    }
  },

  data () {
    let params = Object.assign(
      {
        rows: 10,
        page: 1,
        filter_by: '',
        q: '',
        sort_by: 'id',
        sort: 'desc',
        date_from: '',
        date_to: ''
      },
      this.$route.query
    )

    return {
      params,
      selectedList: null,
      items: [0, 0, 0, 0, 0],

      isDataLoading: true,
      isEmpty: false,
      showDataLoading: false,

      filterBy: [
        {
          value: 'amount',
          display: 'amount'
        },

        {
          value: 'ip',
          display: 'ip'
        },

        {
          value: 'created_at',
          display: 'request date'
        },

        {
          value: 'updated_at',
          display: 'confirm date'
        }
      ],

      dateBy: [
        {
          value: 'created_at',
          display: 'request date'
        },

        {
          value: 'updated_at',
          display: 'confirm date'
        }
      ]
    }
  },

  watch: {
    $route ($router) {
      if (!this.showDataLoading) {
        this.showDataLoading = true
      }
      this.params = this.generate($router.query)
      this.params.rows = 10

      if (this.params.filter_by === 'status') {
        this.params.q = this.params.q.length ? this.params.q[0] : ''
      }

      this.search()
    }
  },

  methods: {
    ...mapActions('transfer', ['getDetail']),

    tempTotal (transfer) {
      if (transfer.status.toLowerCase() !== 'c') {
        return 0
      }
      if ([1, 3].indexOf(transfer.type_id) > -1) {
        return transfer.amount + transfer.old_balance
      }
      return transfer.old_balance - transfer.amount
    },

    async search (query) {
      this.params = query || this.params
      this.params.manual = true
      // == flags reset
      this.isEmpty = false
      if (!this.showDataLoading) {
        this.isDataLoading = true
      }

      let type = 'all'
      if (this.$route.params.subtype === 'cash-in') {
        type = 'cashin'
      }
      if (this.$route.params.subtype === 'cash-out') {
        type = 'cashout'
      }

      await this.getDetail({
        type,
        uid: this.$route.params.id,
        params: this.params
      })

      this.isDataLoading = false
      this.showDataLoading = false
      if (!this.transferDetails.length) {
        this.isEmpty = true
      }
    },

    trigger (query) {
      this.params = query || this.params
      this.$router.push({ query: this.params })
    },

    async sort (sortBy) {
      if (this.params.sort === 'asc') {
        this.params.sort = 'desc'
      } else {
        this.params.sort = 'asc'
      }

      this.params.sort_by = sortBy

      if (!this.showDataLoading) {
        this.showDataLoading = true
      }

      this.$router.push({ query: this.params })
    },

    clear () {

    }

  }

}
</script>
